/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ClientRefResponse
 */
export interface ClientRefResponse {
    /**
     * 
     * @type {string}
     * @memberof ClientRefResponse
     */
    identityId: string;
    /**
     * 
     * @type {string}
     * @memberof ClientRefResponse
     */
    accountId?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientRefResponse
     */
    fullname: string;
}

/**
 * Check if a given object implements the ClientRefResponse interface.
 */
export function instanceOfClientRefResponse(value: object): value is ClientRefResponse {
    if (!('identityId' in value) || value['identityId'] === undefined) return false;
    if (!('fullname' in value) || value['fullname'] === undefined) return false;
    return true;
}

export function ClientRefResponseFromJSON(json: any): ClientRefResponse {
    return ClientRefResponseFromJSONTyped(json, false);
}

export function ClientRefResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClientRefResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'identityId': json['identityId'],
        'accountId': json['accountId'] == null ? undefined : json['accountId'],
        'fullname': json['fullname'],
    };
}

export function ClientRefResponseToJSON(value?: ClientRefResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'identityId': value['identityId'],
        'accountId': value['accountId'],
        'fullname': value['fullname'],
    };
}

